import { createSharedComposable } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import type { BiTrackEventType } from '@eureka/domains/src/bi-track/types';

export const useBiTrack = createSharedComposable((eventType: string) => {
    const biTrackService = injectService<BiTrackService>(BiTrackService);

    function biTrack(params: BiTrackEventType) {
        biTrackService.biTrack(eventType, params);
    }

    return {
        biTrack,
    };
});
